export default "__VITE_ASSET__BEvH8nIs__"